import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components/macro';

const DelegateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 70px;

  margin: 20px auto 0;
  max-width: 400px;
  height: 100%;
`;

const Header = styled.h4`
  margin: 0 0 30px;

  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1.68px;
  text-transform: uppercase;
  color: ${props => props.theme.text2};
`;

const Caption = styled.p`
  font-size: 20px;
  font-weight: 500;
  line-height: 1.05;
  text-align: center;
  color: ${props => props.theme.text0};
`;

const TextWrapper = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.57;
  text-align: center;
  color: ${props => props.theme.text2};
`;

const TextModify = styled.span`
  font-weight: 600;
  color: ${props => props.theme.accent0};
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const animate = keyframes`
  0%, 100% {
    stroke-dashoffset: 440;
  }
  50% {
    stroke-dashoffset: 0;
  }
  50.1% {
    stroke-dashoffset: 880;
  }
`;

const Spinner = styled.svg`
  width: 130px;
  height: 130px;

  position: relative;

  box-shadow: inset 0px 0px 0px 6px rgba(149, 149, 166, 0.19);
  border-radius: 50%;

  transform: translateZ(0);
  animation: ${rotate} 2s linear infinite;
`;

const Circle = styled.circle`
  height: 100%;
  width: 100%;

  fill: none;

  stroke-width: 6;
  stroke: ${props => props.theme.accent0};
  stroke-linecap: round;
  stroke-dasharray: 440;

  animation: ${animate} 4s linear infinite;
`;

export function DelegatePending() {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => navigate('../delegated'), 5000);
  }, [navigate]);

  return (
    <DelegateWrapper>
      <Header>Delegate Assets</Header>
      <Spinner>
        <Circle cx="65" cy="65" r="61" />
      </Spinner>
      <div>
        <Caption>Delegating…</Caption>
        <TextWrapper>
          Delegating <TextModify>2,452.00 NOM</TextModify> to{' '}
          <TextModify>Coinbase Custody</TextModify> validator. You will receive{' '}
          <TextModify>0.3%</TextModify> yield
        </TextWrapper>
      </div>
    </DelegateWrapper>
  );
}
